// src/constants/sidebarItems.js
import {
    Dashboard,
    Category,
    People,
    WorkspacePremium,
    Build,
    Work,
    ViewCarousel,
    ContactMail,
    Settings as SettingsIcon,
    AdminPanelSettings,
    Person,
    Home,
    Article,
    HomeWork,
    ListAlt,
    RateReview,
    FavoriteBorder,
} from "@mui/icons-material";

export const sidebarItems = [
    {
        key: 'dashboard',
        label: { en: 'Dashboard', ar: 'لوحة التحكم' },
        path: '/dashboard',
        icon: Dashboard,
    },
    {
        key: 'users',
        label: { en: 'Users', ar: 'المستخدمين' },
        path: '/users',
        icon: People,
    },
    {
        key: 'categories',
        label: { en: 'Categories', ar: 'الفئات' },
        path: '/categories',
        icon: Category,
    },
    {
        key: 'clients',
        label: { en: 'Clients', ar: 'العملاء' },
        path: '/clients',
        icon: WorkspacePremium,
    },
    {
        key: 'skills',
        label: { en: 'Skills', ar: 'المهارات' },
        path: '/skills',
        icon: Build,
    },
    {
        key: 'services',
        label: { en: 'Services', ar: 'الخدمات' },
        path: '/services',
        icon: Work,
    },
    {
        key: 'projects',
        label: { en: 'Projects', ar: 'المشاريع' },
        path: '/projects',
        icon: Work,
    },
    {
        key: 'sliders',
        label: { en: 'Sliders', ar: 'السلايدر' },
        path: '/sliders',
        icon: ViewCarousel,
    },
    {
        key: 'about',
        label: { en: 'About Sections', ar: 'أقسام من نحن' },
        icon: HomeWork,
        children: [
            {
                key: 'about-home',
                label: { en: 'Home About', ar: 'من نحن (الرئيسية)' },
                path: '/about-home',
                icon: Home,
            },
            {
                key: 'about-page',
                label: { en: 'About Page', ar: 'صفحة من نحن' },
                path: '/about-page',
                icon: Article,
            },
        ],
    },
    {
        key: 'agencies',
        label: { en: 'Agencies', ar: 'الوكالات' },
        icon: WorkspacePremium,
        children: [
            {
                key: 'agencies-section',
                label: { en: 'Agency Section', ar: 'البيانات العامة' },
                path: '/agencies/section',
                icon: Article,
            },
            {
                key: 'agencies-list',
                label: { en: 'All Agencies', ar: 'الوكالات' },
                path: '/agencies',
                icon: WorkspacePremium,
            },
        ],
    },
    {
        key: 'simple-steps',
        label: { en: 'Simple Steps', ar: 'الخطوات البسيطة' },
        icon: ListAlt,
        children: [
            {
                key: 'simple-steps-section',
                label: { en: 'Section Data', ar: 'البيانات العامة' },
                path: '/simple-steps/section',
                icon: Article,
            },
            {
                key: 'simple-steps-items',
                label: { en: 'All Steps', ar: 'جميع الخطوات' },
                path: '/simple-steps',
                icon: ListAlt,
            },
        ],
    },
    {
        key: 'values',
        label: { en: 'Our Values', ar: 'القيم' },
        icon: FavoriteBorder,
        children: [
            {
                key: 'values-section',
                label: { en: 'Section Data', ar: 'البيانات العامة' },
                path: '/values/section',
                icon: Article,
            },
            {
                key: 'values-list',
                label: { en: 'All Values', ar: 'جميع القيم' },
                path: '/values',
                icon: FavoriteBorder,
            },
        ],
    },
    {
        key: 'testimonials',
        label: { en: 'Testimonials', ar: 'الشهادات' },
        icon: RateReview,
        children: [
            {
                key: 'testimonials-section',
                label: { en: 'Section Data', ar: 'البيانات العامة' },
                path: '/testimonials/section',
                icon: Article,
            },
            {
                key: 'testimonials-list',
                label: { en: 'All Testimonials', ar: 'جميع الشهادات' },
                path: '/testimonials',
                icon: RateReview,
            },
        ],
    },
    {
        key: 'contacts',
        label: { en: 'Contacts', ar: 'رسائل التواصل' },
        icon: ContactMail,
        children: [
            {
                key: 'contacts-section',
                label: { en: 'Page Settings', ar: 'إعدادات الصفحة' },
                path: '/contacts/section',
                icon: SettingsIcon,
            },
            // {
            //     key: 'contacts-list',
            //     label: { en: 'Messages', ar: 'الرسائل' },
            //     path: '/contacts',
            //     icon: ContactMail,
            // },
        ],
    },
    {
        key: 'settings',
        label: { en: 'Settings', ar: 'الإعدادات' },
        icon: SettingsIcon,
        children: [
            {
                key: 'settings-general',
                label: { en: 'General', ar: 'عامة' },
                path: '/settings/general',
                icon: SettingsIcon,
            },
            {
                key: 'settings-roles',
                label: { en: 'Roles & Permissions', ar: 'الصلاحيات' },
                path: '/settings/roles',
                icon: AdminPanelSettings,
            },
            {
                key: 'settings-contact',
                label: { en: 'Contact Info', ar: 'معلومات التواصل' },
                path: '/settings/contact',
                icon: ContactMail,
            },
        ],
    },
    {
        key: 'profile',
        label: { en: 'Profile', ar: 'الملف الشخصي' },
        path: '/profile',
        icon: Person,
    },
];
